import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../Context/CartContext";

function Header() {
  const { cartItems, wishlistItems } = useContext(CartContext);

  return (
    <>
      <header>
        <div
          id="vl-header-sticky"
          className="vl-header-area10 header-tranperent"
        >
          <div className="container header2-bg">
            <div className="row align-items-center">
              {/* LOGO */}
              <div className="col-lg-2 col-md-6 col-6">
                <div className="vl-logo">
                  <Link to="/" className="header1-logo-block">
                    <img
                      className="header-logo"
                      src="/assets/img/logo/ashok-nanda-logo.png"
                      alt="Ashok Nanda Logo"
                    />
                  </Link>
                </div>
              </div>

              {/* MENU */}
              <div className="col-lg-7 d-none d-lg-block text-end">
                <div className="vl-main-menu">
                  <nav className="vl-mobile-menu-active">
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li className="has-dropdown">
                        <Link to="/About">About <span><i className="fa-regular fa-angle-down" /></span></Link>
                        <ul className="sub-menu">
                          <li><Link to="/Expertise">Expertise</Link></li>
                          <li><Link to="/Innovation">Innovation</Link></li>
                        </ul>
                      </li>
                      <li><Link to="/Activities">Activities</Link></li>
                      <li className="has-dropdown"><Link to="/Gallery">Gallery</Link></li>
                      <li><Link to="/Blog">Blog</Link></li>
                      <li className="has-dropdown">
                        <Link to="">Book <span><i className="fa-regular fa-angle-down" /></span></Link>
                        <ul className="sub-menu">
                          <li><Link to="/Published">Published Book</Link></li>
                          <li><Link to="">Waiting For Publication</Link></li>
                        </ul>
                      </li>
                     
                    </ul>
                  </nav>
                </div>
              </div>

              {/* RIGHT SIDE ICONS */}
              <div className="col-lg-3 col-md-6 col-6">
                <div className="vl-header8-btns text-end d-none d-lg-block">
                  <div className="buttons d-flex align-items-center justify-content-end">
                    {/* Search */}
                    <div className="vl-search1 me-3">
                      {/* <button className="search-open-btn">
                        <i className="fa-regular fa-magnifying-glass" />
                      </button> */}
                    </div>

                    {/* Wishlist */}
                    <div className="wishlist-icon me-3">
                      <Link to="/wishlist" className="icon-btn">
                        <i className="fa-regular fa-heart"></i>
                        {wishlistItems.length > 0 && (
                          <span className="count-badge">
                            {wishlistItems.length}
                          </span>
                        )}
                      </Link>
                    </div>

                    {/* Cart */}
                    <div className="cart-icon me-3">
                      <Link to="/cart" className="icon-btn">
                        <i className="fa-solid fa-cart-shopping"></i>
                        {cartItems.length > 0 && (
                          <span className="count-badge">
                            {cartItems.length}
                          </span>
                        )}
                      </Link>
                    </div>

                    {/* LOGIN SECTION - Links to /login page */}
                    <div className="login-btn-area">
                        <Link 
                            to="/login" 
                            className="d-flex align-items-center gap-2"
                            style={{ textDecoration: 'none', color: 'inherit', fontWeight: '500' }}
                        >
                            <i className="fa-regular fa-user"></i>
                            <span>Login</span>
                        </Link>
                    </div>

                  </div>
                </div>

                {/* Mobile menu icon */}
                <div className="vl-header-action-item d-block d-lg-none">
                  <button type="button" className="vl-offcanvas-toggle">
                    <i className="fa-duotone fa-solid fa-bars-staggered" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* MOBILE NAV */}
      <div className="vl-offcanvas vl-header-area1">
        <div className="vl-offcanvas-wrap">
          <div className="vl-offcanvas-header">
            <div className="vl-offcanvas-logo">
              <Link to="/" className="header1-logo-block">
                <img
                  className="header-logo"
                  src="/assets/img/logo/ashok-nanda-logo.png"
                  alt="Ashok Nanda Logo"
                />
              </Link>
            </div>
            <div className="vl-offcanvas-close">
              <button className="vl-offcanvas-close-toggle">
                <i className="fa-regular fa-xmark" />
              </button>
            </div>
          </div>

          <div className="vl-offcanvas-menu">
            <nav />
          </div>

          <div className="vl-offcanvas-info">
            
          </div>
        </div>
      </div>
      <div className="vl-offcanvas-overlay" />
    </>
  );
}

export default Header;